import accounts from "./accounts/actions";
import altAssets from "./alt-assets/actions";
import appSettings from "./app-settings/actions";
import assetAuditors from "./asset-auditors/actions";
import assetFoundElsewhere from "./asset-found-elsewhere/actions";
import assets from "./assets/actions";
import assetSync from "./asset-sync/actions";
import assetLookup from "./asset-lookup/actions";
import assignmentDetails from "./assignment-details/actions";
import auditArchive from "./audit-archive/actions";
import auditAssets from "./audit-assets/actions";
import auditAssignments from "./audit-assignments/actions";
import auditControllers from "./audit-controllers/actions";
import auditFilters from "./audit-filters/actions";
import auditGroups from "./audit-groups/actions";
import auditImages from "./audit-images/actions";
import auditLocations from "./audit-locations/actions";
import auditResendAssignmentEmail from "./audit-resend-assignment-email/actions";
import auditReview from "./audit-review/actions";
import audits from "./audits/actions";
import auditsList from "./audits-list/actions";
import auditsCreate from "./audits-create/actions";
import auditSubmissions from "./audit-submissions/actions";
import auditRating from "./audit-rating/actions";
import auth from "./auth/actions";
import branches from "./branches/actions";
import branchLocations from "./branch-locations/actions";

import dashboard from "./dashboard-store/actions";
import dataCheck from "./data-check/actions";
import dealerContacts from "./dealer-contacts/actions";
import financeTypes from "./finance-types/actions";
import http from "./http/actions";
import locations from "./locations/actions";
import organisations from "./organisations/actions";
import organisationSettings from "./organisation-settings/actions";
import powerbi from "./powerbi/actions";
import skipTrace from "./skip-trace/actions";
import toast from "./toast/actions";
import typesList from "./types-list/actions";
import userLanguage from "./user-language/actions";
import userLocations from "./user-locations/actions";
import userOrganisations from "./user-organisations/actions";
import userWelcomeRequest from "./user-welcome-requests/actions";
import validationErrors from "./validation-errors/actions";
import validatedVisibility from "./validated-visibility-assets/actions";
import auditComments from "./audit-comment/actions";
import vinDecoder from "./vin-decoder/actions";

export default {
    accounts,
    altAssets,
    appSettings,
    assetAuditors,
    assetFoundElsewhere,
    assets,
    assetLookup,
    assetSync,
    assignmentDetails,
    auditArchive,
    auditAssets,
    auditAssignments,
    auditControllers,
    auditFilters,
    auditGroups,
    auditImages,
    auditLocations,
    auditResendAssignmentEmail,
    auditRating,
    auditReview,
    audits,
    auditsList,
    auditsCreate,
    auditComments,
    auditSubmissions,
    auth,
    branches,
    branchLocations,
    dashboard,
    dataCheck,
    dealerContacts,
    financeTypes,
    http,
    locations,
    organisations,
    organisationSettings,
    powerbi,
    skipTrace,
    toast,
    typesList,
    userLanguage,
    userLocations,
    userOrganisations,
    userWelcomeRequest,
    vinDecoder,
    validationErrors,
    validatedVisibility
};
